import * as Context from "effect/Context";
/** Implementations are acquired with an Effect Layer/Scope. Closing the enclosing Scope
 * cancels jobs, waits for their cleanup barriers, terminates connections and releases URLs.
 * Session disposal first stops its policy fibers, then lets this resource Scope close.
 */
export class EditorCapabilities extends Context.Service()("@linempo/application/EditorCapabilities") {
}
